/**
 * @namespace Header
 * @aka SWRNEU.Header
 */
SWRNEU.Header = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'header';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '#header'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Header = function () {

    function Header (element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      init();

      //Nach PJAX-Navigation:
      $(document).on(Event.PJAX_DATA_API, function () {
        init();
      });

      function init () {
        self.$firstLevelRight = $('#header-navi-first-level-right');
        self.$secondLevel = $('#header-navi-second-level');
        self.$secondLevelSublists = $('#header-navi-second-level .dropdown .dropdown-menu');
        self.$login = $('#header-navi-login');
        self.$loginButton = $('#login-button');
        self.$loginDropdown = $('#header-navi-login-dropdown');
        self.$loggedOutDropdown = $('#header-navi-logged-out-dropdown');
        self.$contentWrapper = $('#content-wrapper');
        self.$openMenuButton = $('button.open-side-menu');
        self.$closeMenuButton = $('button.close-side-menu');
        self.$firstLevelRight.trigger('swr:collapse:hide');

        //Nach PJAX-Navigation soll der Backdrop ausgeblendet
        //und der Suchschlitz geleert werden.
        self._hideBackdrop();
        self.$firstLevelRight.find('input[name="swx_q"]').val('').blur();

        if ($('body').hasClass('rubrik-swrherzenssache')) {
          //Für die Herzenssache müssen der Menü-Öffnen und -Schließen-Button
          //zusätzliche Klassen bekommen
          self.$element.find('button.open-side-menu').addClass('btn btn-tertiary btn-tertiary-neutral btn-medium');
          self.$element.find('button.close-side-menu').addClass('btn btn-tertiary btn-tertiary-neutral btn-medium');
        }

        self._addKeyHandler();
        self._addClickHandler();
        self._addCollapseEventListener();
        self._halfSticky();
      }
    };

    Header.prototype._addKeyHandler = function _addKeyHandler () {
      var self = this;

      $(document).on('keydown', function (event) {
        var $element = $(event.target);
        console.log($element);

        if ($element.closest('.breadcrumbs').length === 0 && $element.closest(self.$element).length === 0) {
          //Wenn das Element außerhalb des Headers liegt,
          //hören wir hier auf.
          return;
        }

        const elProps = self._getElementProperties($element);

        switch (event.key) {
          case 'Escape': {
            //Wenn wir uns im Side-Menu befinden, soll es geschlossen
            //werden und der Fokus muss versetzt werden.
            if (elProps.isSideMenuOpen && (elProps.isInSideMenu || elProps.isSideMenuOpen) && !elProps.isInSideMenuSearch) {
              self.$firstLevelRight.trigger('swr:collapse:hide');
              self._hideBackdrop();

              if (self.$loginButton !== undefined) {
                //Wenn es einen Login-Button gibt, wird dieser fokussiert.
                self.$loginButton.trigger('focus');
              } else if (self.$secondLevel !== undefined) {
                //Falls es keinen Login-Button gibt, aber eine Second-Level-Navi
                //wird dort das erste fokussierbare Element fokussiert.
                self.$secondLevel.find('a, button').first().trigger('focus');
              } else {
                //Andernfalls wird der erste Eintrag der Breadcrumbs fokussiert.
                $('.breadcrumbs').find('a').first().trigger('focus');
              }
            }

            //Wenn wir uns in einer Subliste der Secondary-Navi befinden,
            //muss diese geschlossen werden und der nächste Punkt in der Second-Level-Navi
            //wird fokussiert.
            if (elProps.isInSecondaryMenu && elProps.secondaryMenuHasOpenSublist) {
              const openSublist = self.$secondLevel.find('.show');
              const nextElement = openSublist.closest('li').next().find('a, button');

              openSublist.trigger('swr:collapse:hide');
              self._hideBackdrop();

              if (nextElement !== undefined) {
                //Wenn es ein nächstes Element in der Second-Level-Navi gibt,
                //wird dieses fokussiert.
                nextElement.trigger('focus');
              } else {
                //Andernfalls wird der erste Eintrag der Breadcrumbs fokussiert.
                $('.breadcrumbs').find('a').first().trigger('focus');
              }
            }

            //Wenn wir uns in der Suche befinden, muss das Eingabefeld
            //geleert werden und die Suche muss geschlossen werden. Außerdem muss
            //der erste Navi-Punkt fokussiert werden
            if (elProps.isInSideMenuSearch && !elProps.isSearchDismissButton) {
              self.$firstLevelRight.removeClass('search-open');
              $('input[name="swx_q"]').val('').blur();
              $('#navbar-side-menu li a').first().trigger('focus');
            }

            //Wenn wir uns im Login-Dropdown befinden, soll es geschlossen werden
            //und der Fokus muss versetzt werden
            if ((elProps.isInLoginDropdown || elProps.isInLoggedOutDropdown) && (elProps.isLoginDropdownOpen || elProps.isLoggedOutDropdownOpen)) {
              self.$loginDropdown.trigger('swr:collapse:hide');
              self.$loggedOutDropdown.trigger('swr:collapse:hide');
              self._hideBackdrop();

              if (self.$secondLevel !== undefined) {
                //Wenn es eine Second-Level-Navi gibt,
                //wird dort das erste fokussierbare Element fokussiert.
                self.$secondLevel.find('a, button').first().trigger('focus');
              } else {
                //Andernfalls wird der erste Eintrag der Breadcrumbs fokussiert.
                $('.breadcrumbs').find('a').first().trigger('focus');
              }
            }
            break;
          }
          case 'Enter': {
            //Wenn der "Menü öffnen"-Button getriggert wurde und das
            //Side-Menü geschlossen ist, dann soll es geöffnet werden,
            //der Backdrop eingeblendet und der "Menü schließen"-Button
            //fokussiert werden.
            if (elProps.isSideMenuButton && !elProps.isSideMenuOpen) {
              self._showBackdrop();

              //Kleiner Timeout, damit der Button kein display:none
              //mehr hat. Beim Öffnen des Side-Menu, soll der
              //"Menü schließen"-Button fokussiert werden.
              window.setTimeout(function () {
                self.$closeMenuButton.trigger('focus');
              }, 50);
            }

            //Wenn der "Menü schließen"-Button getriggert wurde, dann
            //wird die Side-Navi geschlossen und der Backdrop ausgeblendet.
            if (elProps.isCloseMenuButton) {
              self._hideBackdrop();
              self.$openMenuButton.trigger('focus');
            }

            //Wenn wir uns in der geöffneten Suche befinden und der
            //"Suche-Abbrechen"-Button getriggert wurde, muss das Eingabefeld
            //geleert werden und die Suche muss geschlossen werden. Außerdem muss
            //der erste Navi-Punkt fokussiert werden
            if (elProps.isInSideMenuSearch && elProps.isSearchDismissButton) {
              self.$firstLevelRight.removeClass('search-open');
              $('input[name="swx_q"]').val('').blur();
              $('#navbar-side-menu li a').first().trigger('focus');
            }
            break;
          }
          case 'Tab': {
            //Da wir auf das "KEYDOWN"-Event reagieren, ist das $element (dessen
            //Element-Properties geholt werden) fokussiert gewesen, als die
            //Tab-Taste gedrückt wurde.

            if (event.shiftKey === true) {
              //Rückwärts getabbt:

              //isFirstInSideMenu sagt, ob das Element, auf dem der Tab ausgelöst wurde,
              //das erste Element ist. Wenn ja, dann muss das Side-Menu geschlossen, der
              //"Menü öffnen"-Button fokussiert und der Backdrop muss ausgeblendet werden.
              if (elProps.isInSideMenu && elProps.isFirstInSideMenu) {
                self.$firstLevelRight.trigger('swr:collapse:hide');
                self._hideBackdrop();

                event.preventDefault();
                event.stopPropagation();
                self.$openMenuButton.trigger('focus');
              }

              //isFirstInOpenSublist sagt, ob das Element, auf dem der Tab ausgelöst wurde,
              //das erste Element in einer Sublist der Second-Level-Navi ist. Wenn ja,
              //werden alle Sublists der Second-Level-Navi geschlossen und der Backdrop
              //wird ausgeblendet.
              if (elProps.secondaryMenuExists) {
                if (elProps.secondaryMenuHasOpenSublist && elProps.isInOpenSublist && elProps.isFirstInOpenSublist) {
                  self.$secondLevel.find('.show, .showing').each(function () {
                    $(this).trigger('swr:collapse:hide');
                  });

                  self._hideBackdrop();
                }
              }

              //isFirstInLoginDropdown und isFirstInLoggedOutDropdown besagen,
              //dass das Element das erste in einem der beiden Dropdowns ist.
              //Wenn ja, wird dieses geschlossen und der Backdrop wird ausgeblendet.
              if (elProps.loginExists) {
                if (elProps.isInLoggedOutDropdown && elProps.isFirstInLoggedOutDropdown) {
                  self.$loggedOutDropdown.trigger('swr:collapse:hide');
                  self._hideBackdrop();
                }

                if (elProps.isInLoginDropdown && elProps.isFirstInLoginDropdown) {
                  self.$loginDropdown.trigger('swr:collapse:hide');
                  self._hideBackdrop();
                }
              }
            } else {
              //Vorwärts getabbt:

              //isLastInSideMenu sagt, ob das Element, auf dem der Tab ausgelöst wurde,
              //das letzte Element ist. Wenn ja, dann muss das Side-Menu geschlossen
              //werden und der Backdrop muss ausgeblendet werden.
              if (elProps.isInSideMenu && elProps.isLastInSideMenu) {
                self.$firstLevelRight.trigger('swr:collapse:hide');
                self._hideBackdrop();

                //Wenn der Login existiert, dann soll nicht in die Second-Level-Navi
                //oder zu den Breadcrumbs getabbt werden, sondern zum Login-Button
                if (elProps.loginExists) {
                  event.preventDefault();
                  event.stopPropagation();
                  self.$loginButton.trigger('focus');
                }
              }

              //isLastInOpenSublist sagt, ob das Element, auf dem der Tab ausgelöst wurde,
              //das erste Element in einer Sublist der Second-Level-Navi ist. Wenn ja,
              //werden alle Sublists der Second-Level-Navi geschlossen und der Backdrop
              //wird ausgeblendet.
              if (elProps.secondaryMenuExists) {
                if (elProps.secondaryMenuHasOpenSublist && elProps.isInOpenSublist && elProps.isLastInOpenSublist) {
                  self.$secondLevel.find('.show, .showing').each(function () {
                    $(this).trigger('swr:collapse:hide');
                  });

                  self._hideBackdrop();
                }
              }

              //isLastInLoginDropdown und isLastInLoggedOutDropdown besagen,
              //dass das Element das letzte in einem der beiden Dropdowns ist.
              //Wenn ja, wird dieses geschlossen und der Backdrop wird ausgeblendet.
              if (elProps.loginExists) {
                if (elProps.isInLoggedOutDropdown && elProps.isLastInLoggedOutDropdown) {
                  self.$loggedOutDropdown.trigger('swr:collapse:hide');
                  self._hideBackdrop();
                }

                if (elProps.isInLoginDropdown && elProps.isLastInLoginDropdown) {
                  self.$loginDropdown.trigger('swr:collapse:hide');
                  self._hideBackdrop();
                }
              }
            }

            //Für beide Tabrichtungen gilt:
            //Wenn in die Suche reingetabbt wurde, wird die Suche geöffnet
            if (elProps.isSearch) {
              self.$firstLevelRight.addClass('search-open');
            }

            //Wenn aus der Suche herausgetabbt wurde, wird die Suche geschlossen
            if (!elProps.isInSideMenuSearch && elProps.isSearchOpen) {
              self.$firstLevelRight.removeClass('search-open');
            }
          }
        }
      });
    };

    Header.prototype._addClickHandler = function _addClickHandler () {
      const self = this;

      $(document).on('click' + EVENT_KEY + DATA_API_KEY, function (event) {
        let element = event.target;
        let $element = $(element);

        if (!self.$contentWrapper.hasClass('menu-open') && !self.$contentWrapper.hasClass('closing')) {
          // Hier beenden, wenn kein Menü auf ist
          return;
        }

        if (event.target.tagName !== 'BUTTON') {
          //Es wird geschaut, ob das Element in einem Button liegt.
          var $closest = $element.closest('button');
          if ($closest.length === 0) {
            //Es wird geschaut, ob das Element in einem Link liegt
            if (event.target.tagName !== 'A') {
              $closest = $element.closest('a');
            }
          }

          if ($closest.length !== 0) {
            element = $closest[0];
            $element = $(element);
          }
        }

        const elProps = self._getElementProperties($element);

        //Wenn der Klick außerhalb des Side-Menu, der Second-Level-Navi
        //und des Login-Dropdowns liegt, soll der Backdrop ausgeblendet werden
        //und alle geöffneten Menüs sollen geschlossen werden
        if (!elProps.isInSideMenu && !elProps.isInSecondaryMenu && !elProps.isInLoginDropdown && !elProps.isInLoggedOutDropdown && !elProps.isSideMenu && !elProps.isSecondaryMenu && !elProps.isLoginDropdown && !elProps.isLoggedOutDropdown && !elProps.isSideMenuButton && !elProps.isLoginButton) {
          self.$firstLevelRight.trigger('swr:collapse:hide');
          self.$loginDropdown.add(self.$loggedOutDropdown).trigger('swr:collapse:hide');

          self.$secondLevel.find('.show, .showing').each(function () {
            // Alle Sublists der Second-Level-Navi werden geschlossen
            $(this).trigger('swr:collapse:hide');
          });

          // Suchfeld leeren
          self.$firstLevelRight.find('input[name="swx_q"]').val('');
          self._hideBackdrop();
        }

        //Wenn das Side-Menu geöffnet ist und auf den "Menü"-Button
        //geklickt wurde, dann wird das Side-Menu geschlossen
        //und entsprechend soll auch der Backdrop ausgeblendet werden
        if (elProps.isSideMenuButton && elProps.isSideMenuOpen) {
          self._hideBackdrop();
        }

        //Wenn das Side-Menu geöffnet ist und auf den "Schließen"-Button
        //geklickt wurde, dann wird das Side-Menu geschlossen
        //und entsprechend soll auch der Backdrop ausgeblendet werden
        if (elProps.isCloseMenuButton && elProps.isSideMenuOpen) {
          self._hideBackdrop();
        }

        //Wenn das Side-Menu oder ein Dropdown der SecondLevelNavi geöffnet ist,
        //auf die SecondLevelNavi geklickt wird, aber nicht auf einen Button darin,
        //werden das Side-Menu und alle Sublisten der SecondLevelNavi geschlossen.
        if (elProps.isInSecondaryMenu && (elProps.isSideMenuOpen || elProps.secondaryMenuHasOpenSublist || elProps.secondaryMenuHasOpeningSublists) && !elProps.isSideMenuButton && !elProps.isSecondaryMenuDropdownButton) {
          self.$firstLevelRight.trigger('swr:collapse:hide');
          self.$secondLevel.find('.show, .showing').each(function () {
            $(this).trigger('swr:collapse:hide');
          });

          self._hideBackdrop();
        }

        //Wenn der Klick auf einem Element im Side-Menu liegt, es nicht das
        //Side-Menu selbst und nicht der "Schließen"-Button war,
        //wird geprüft, ob es ein Link war
        if (elProps.isInSideMenu && !elProps.isSideMenu && !elProps.isCloseMenuButton && elProps.isSideMenuOpen) {
          if (element.tagName === 'A') {
            //Wenn es ein Link ist, dann wird das Side-Menu geschlossen und
            //der Backdrop ausgeblendet
            self.$firstLevelRight.trigger('swr:collapse:hide');
            self._hideBackdrop();
          }
        }

        //Wenn der Klick auf einem Dropdown-Button in der Secondary-Navi liegt
        //und es der Button der Liste war, die schon offen war, dann muss der
        //Backdrop ausgeblendet werden
        if (elProps.isSecondaryMenuDropdownButton && !elProps.secondaryMenuHasOpeningSublists) {
          self._hideBackdrop();
        }

        //Wenn der Klick auf einem Element in der Secondary-Navi liegt,
        //es nicht die Secondary-Navi selbst und wenn es nicht der
        //Dropdown-Button einer Liste war, wird geprüft, ob es ein Link ist
        if (elProps.isInSecondaryMenu && elProps.secondaryMenuHasOpenSublist && !elProps.isSecondaryMenu && !elProps.isSecondaryMenuDropdownButton) {
          if (element.tagName === 'A') {
            //Wenn es ein Link ist, dann werden alle Sublisten der Secondary-Navi
            //geschlossen und der Backdrop ausgeblendet.

            self.$secondLevel.find('.show, .showing').each(function () {
              $(this).trigger('swr:collapse:hide');
            });

            self._hideBackdrop();
          }
        }

        //Wenn der Klick auf dem Login-Button liegt und das Login-Dropdown
        //offen ist, soll der Backdrop ausgeblendet werden
        if (elProps.isLoginButton && (elProps.isLoginDropdownOpen || elProps.isLoggedOutDropdownOpen)) {
          self._hideBackdrop();
        }

        //Wenn der Klick im Login-Dropdown liegt und es ein Link ist,
        //soll der Backdrop ausgeblendet werden und das Dropdown
        //geschlossen werden
        if (elProps.isInLoginDropdown || elProps.isInLoggedOutDropdown) {
          if (element.tagName === 'A') {
            self.$loginDropdown.add(self.$loggedOutDropdown).trigger('swr:collapse:hide');
            self._hideBackdrop();
          }
        }

        //Es wurde in die Suche geklickt und das Side-Menu muss die
        //Info bekommen, dass die Suche nun offen ist
        if (elProps.isInSideMenuSearch && !elProps.isSearchDismissButton) {
          self.$firstLevelRight.addClass('search-open');
        }

        //Es wurde auf den "Suche-Abbrechen"-Button geklickt und
        //das Side-Menu muss die Info bekommen, dass die Suche
        //geschlossen wird
        if (elProps.isInSideMenuSearch && elProps.isSearchDismissButton) {
          self.$firstLevelRight.removeClass('search-open');
        }

        //Es wurde außerhalb der Suche geklickt und
        //das Side-Menu muss die Info bekommen, dass die Suche
        //geschlossen wird
        if (!elProps.isSearch) {
          self.$firstLevelRight.removeClass('search-open');
        }
      });

      //Der Suche-Verwerfen-Button
      $('.btn-dismiss-search').on('click', function () {
        $('input[name="swx_q"]').val('');
      });
    };

    Header.prototype._addCollapseEventListener = function _addCollapseEventListener () {
      var self = this;

      //Wenn eine der Listen geöffnet wird,
      //werden alle anderen Menüs geschlossen:
      self.$secondLevelSublists.each(function () {
        $(this).on('swr:collapse:showing', function () {
          self.$firstLevelRight.trigger('swr:collapse:hide');
          self.$loginDropdown.add(self.$loggedOutDropdown).trigger('swr:collapse:hide');

          self._showBackdrop();
        });
      });

      //Wenn keine andere Liste geöffnet ist,
      //soll der Backdrop ausgeblendet werden:
      self.$secondLevelSublists.each(function () {
        $(this).on('swr:collapse:hiding', function () {
          if (self.$secondLevel.find('.show, .showing').length === 0) {
            self._hideBackdrop();
          }
        });
      });

      //Wenn der Login-Dropdown oder der LoggedOut-Dropdown geöffnet wird,
      //werden alle anderen Menüs geschlossen:
      self.$loginDropdown.add(self.$loggedOutDropdown).on('swr:collapse:showing', function () {
        self.$firstLevelRight.trigger('swr:collapse:hide');
        self.$secondLevelSublists.each(function () {
          $(this).trigger('swr:collapse:hide');
        });

        self._showBackdrop();
      });

      //Wenn das Side-Menu geöffnet wird,
      //werden alle anderen Menüs geschlossen:
      self.$firstLevelRight.on('swr:collapse:showing', function () {
        self.$loginDropdown.add(self.$loggedOutDropdown).trigger('swr:collapse:hide');
        self.$secondLevelSublists.each(function () {
          $(this).trigger('swr:collapse:hide');
        });

        self._showBackdrop();
      });

      //Wenn das Side-Menu geschlossen wird, werden
      //alle darin enthaltenen Sublists geschlossen:
      self.$firstLevelRight.on('swr:collapse:hiding', function () {
        self.$firstLevelRight.find('.dropdown-menu').each(function () {
          $(this).trigger('swr:collapse:hide');
        });
      });
    };

    Header.prototype._halfSticky = function _halfSticky () {
      var self = this;
      var init = true;
      var lastScrollPosition = 0;

      $(document).on('swr:scroll:scrolled', (event, data) => hasScrolled(data));

      function hasScrolled (data) {
        var scrollTop = data.position;

        if (init) {
          lastScrollPosition = scrollTop;
          init = false;
        }

        if (scrollTop > lastScrollPosition + 50) {
          //Ausblenden:
          if (!self.$contentWrapper.hasClass('menu-open')) {
            self.$element.addClass('nav-up').removeClass('nav-down');
          }
          lastScrollPosition = scrollTop;
        } else if (lastScrollPosition - scrollTop > 300 || scrollTop === 0 && lastScrollPosition > scrollTop) {
          //Einblenden:
          if (!self.$contentWrapper.hasClass('menu-open')) {
            self.$element.removeClass('nav-up').addClass('nav-down');
          }
          lastScrollPosition = scrollTop;
        }
      }
    };

    Header.prototype._showBackdrop = function showBackdrop () {
      const self = this;
      self.$contentWrapper.addClass('menu-open');
      self.backdropVisible = true;
    };

    Header.prototype._hideBackdrop = function hideBackdrop () {
      const self = this;
      self.$contentWrapper.addClass('closing');

      window.setTimeout(function () {
        self.$contentWrapper.removeClass('menu-open').removeClass('closing');
        self.backdropVisible = false;
      }, 500);
    };

    Header.prototype._getElementProperties = function _getElementProperties ($element) {
      var self = this;

      let properties = {
        /***Allgemeine Side-Menu-Informationen:***/
        //Ist das Element der "Menü öffnen"-Button?
        isSideMenuButton: false,

        //Ist das Side-Menu offen?
        isSideMenuOpen: false,

        //Ist das Element das Side-Menu selbst?
        isSideMenu: false,

        //Ist das Element der "Menü schließen"-Button?
        isCloseMenuButton: false,

        //Befindet sich das Element im Side-Menu?
        isInSideMenu: false,

        //Ist das Element das erste im Side-Menu?
        isFirstInSideMenu: false,

        //Ist das Element das letzte im Side-Menu?
        isLastInSideMenu: false,

        /***Suche:***/
        //Ist das Element das Suchformular?
        isSearch: false,

        //Ist die Suche offen?
        isSearchOpen: false,

        //Ist das Element in der Suche?
        isInSideMenuSearch: false,

        //Ist das Element der "Suche schließen"-Button?
        isSearchDismissButton: false,

        /***Second-Level-Navigation:***/
        //Gibt es eine Second-Level-Navigation?
        secondaryMenuExists: false,

        //Ist das Element die Second-Level-Navigation?
        isSecondaryMenu: false,

        //Befindet sich das Element in der Second-Level-Navigation?
        isInSecondaryMenu: false,

        //Hat die Second-Level-Navigation eine geöffnete Subliste?
        secondaryMenuHasOpenSublist: false,

        //Hat die Second-Level-Navigation eine sich öffnende Subliste?
        secondaryMenuHasOpeningSublists: false,

        //Ist das Element ein Button einer Subliste?
        isSecondaryMenuDropdownButton: false,

        //Ist das Element eine geöffnete Subliste?
        isOpenSublist: false,

        //Befindet sich das Element in einer geöffneten Subliste?
        isInOpenSublist: false,

        //Ist das Element das erste Element in einer geöffneten Subliste?
        isFirstInOpenSublist: false,

        //Ist das Element das letzte Element in einer geöffneten Subliste?
        isLastInOpenSublist: false,

        /***ARD-Login:***/
        //Gibt es den Login?
        loginExists: false,

        //Ist das Element der Login-Bereich?
        isLogin: false,

        //Ist das Element der Login-Button?
        isLoginButton: false,

        //Ist das "Login-Dropdown" geöffnet?
        isLoginDropdownOpen: false,

        //Ist das "Login-Dropdown für ausgeloggte Nutzer" geöffnet?
        isLoggedOutDropdownOpen: false,

        //Ist das Element das "Login-Dropdown"?
        isLoginDropdown: false,

        //Befindet sich das Element im "Login-Dropdown"?
        isInLoginDropdown: false,

        //Ist das Element das erste im "Login-Dropdown"?
        isFirstInLoginDropdown: false,

        //Ist das Element das letzte im "Login-Dropdown"?
        isLastInLoginDropdown: false,

        //Ist das Element das "Login-Dropdown für ausgeloggte Nutzer"?
        isLoggedOutDropdown: false,

        //Befindet sich das Element im "Login-Dropdown für ausgeloggte Nutzer"?
        isInLoggedOutDropdown: false,

        //Ist das Element das erste im "Login-Dropdown für ausgeloggte Nutzer"?
        isFirstInLoggedOutDropdown: false,

        //Ist das Element das letzte im "Login-Dropdown für ausgeloggte Nutzer"?
        isLastInLoggedOutDropdown: false
      };

      /***Allgemeine Side-Menu-Informationen:***/
      properties.isSideMenuButton = $element.hasClass('open-side-menu');
      properties.isSideMenuOpen = self.$firstLevelRight.is('.hiding, .show');

      if (properties.isSideMenuOpen) {
        //Wenn das Side-Menu geöffnet ist, können diese Werte
        //gesetzt werden. Vorher macht es keinen Sinn
        properties.isSideMenu = self.$firstLevelRight.is($element);
        properties.isCloseMenuButton = self.$closeMenuButton.is($element);
        properties.isInSideMenu = self.$firstLevelRight.find($element).length !== 0;
        properties.isFirstInSideMenu = properties.isCloseMenuButton;
        properties.isLastInSideMenu = isLastInSideMenu();

        /***Suche:***/
        properties.isSearch = $element.closest('form.navbar-search').length !== 0;
        properties.isSearchOpen = self.$firstLevelRight.hasClass('search-open');
        properties.isInSideMenuSearch = $element.closest('div.navbar-search').length !== 0;
        properties.isSearchDismissButton = $element.hasClass('btn-dismiss-search');
      }

      /***Second-Level-Navigation:***/
      properties.secondaryMenuExists = self.$secondLevel.length !== 0;

      if (properties.secondaryMenuExists) {
        //Wenn es eine Second-Level-Navigation gibt, können diese Werte
        //gesetzt werden. Vorher macht es keinen Sinn
        properties.isSecondaryMenu = self.$secondLevel.is($element);
        properties.isInSecondaryMenu = self.$secondLevel.find($element).length !== 0;
        properties.secondaryMenuHasOpenSublist = self.$secondLevel.find('.dropdown-menu').filter((index, el) => $(el).is('.show')).length !== 0;
        properties.secondaryMenuHasOpeningSublists = self.$secondLevel.find('.dropdown-menu').filter((index, el) => $(el).is('.showing, .show')).length !== 0;
        properties.isSecondaryMenuDropdownButton = self.$secondLevel.find('button[data-toggle="collapse"]').filter((index, el) => $(el).is($element)).length !== 0;

        if (properties.secondaryMenuHasOpenSublist || properties.secondaryMenuHasOpeningSublists) {
          //Wenn es eine geöffnete oder eine sich öffnende Sublist gibt,
          //können diese Werte gesetzt werden. Vorher macht es keinen Sinn
          properties.isOpenSublist = self.$secondLevel.find('.dropdown-menu.showing, .dropdown-menu.show').filter((index, el) => $(el).is($element)).length !== 0;
          properties.isInOpenSublist = self.$secondLevel.find('.dropdown-menu.showing, .dropdown-menu.show').filter((index, el) => $(el).find($element).length !== 0).length !== 0;

          if (properties.isInOpenSublist) {
            //Wenn sich das Element in einer geöffneten Subliste befindet,
            //können diese Werte gesetzt werden. Vorher macht es keinen Sinn
            properties.isFirstInOpenSublist = isFirstInList($element.closest('ul'));
            properties.isLastInOpenSublist = isLastInList($element.closest('ul'));
          }
        }
      }

      /***ARD-Login:***/
      properties.loginExists = self.$login.length !== 0;

      if (properties.loginExists) {
        //Wenn es den Login-Bereich gibt, können diese Werte
        //gesetzt werden. Vorher macht es keinen Sinn

        properties.isLogin = self.$login.is($element);
        properties.isLoginButton = $element.is(self.$loginButton);
        properties.isLoginDropdownOpen = self.$loginDropdown.is('.hiding, .show');
        properties.isLoggedOutDropdownOpen = self.$loggedOutDropdown.is('.hiding, .show');

        if (properties.isLoginDropdownOpen) {
          //Wenn das "Login-Dropdown" geöffnet ist, können diese Werte
          //gesetzt werden. Vorher macht es keinen Sinn
          properties.isLoginDropdown = self.$loginDropdown.is($element);
          properties.isInLoginDropdown = self.$loginDropdown.find($element).length !== 0;
          properties.isFirstInLoginDropdown = isFirstInList(self.$loginDropdown);
          properties.isLastInLoginDropdown = isLastInList(self.$loginDropdown);
        }

        if (properties.isLoggedOutDropdownOpen) {
          //Wenn das "Login-Dropdown für ausgeloggte Nutzer" geöffnet ist,
          //können diese Werte gesetzt werden. Vorher macht es keinen Sinn
          properties.isLoggedOutDropdown = self.$loggedOutDropdown.is($element);
          properties.isInLoggedOutDropdown = self.$loggedOutDropdown.find($element).length !== 0;
          properties.isFirstInLoggedOutDropdown = isFirstInList(self.$loggedOutDropdown);
          properties.isLastInLoggedOutDropdown = isLastInList(self.$loggedOutDropdown);
        }
      }

      return properties;

      //Hilfsfunktionen:
      function isLastInSideMenu () {
        let result = false;
        let isInSideMenu = self.$firstLevelRight.find($element).length !== 0;

        if (isInSideMenu) {
          const $navbarSideMenu = $('#navbar-side-menu > ul');
          let sideMenuElements = $navbarSideMenu.find('> li, > li .showing li, > li .show li').toArray();

          result = isLastInListArray(sideMenuElements);
        }
        return result;
      }

      function isLastInList ($list) {
        const listElements = $list.find('li').toArray();

        return isLastInListArray(listElements);
      }

      function isLastInListArray (listArray) {
        let indexOfElement = 0;
        const length = listArray.length;

        for (const [index, li] of listArray.entries()) {
          const $closestLi = $element.closest('li');

          if ($(li).is($closestLi)) {
            indexOfElement = index;
            break;
          }
        }

        return indexOfElement === length - 1;
      }

      function isFirstInList ($list) {
        const listElements = $list.find('li').toArray();

        return isFirstInListArray(listElements);
      }

      function isFirstInListArray (listArray) {
        let indexOfElement = 0;

        for (const [index, li] of listArray.entries()) {
          const $closestLi = $element.closest('li');

          if ($(li).is($closestLi)) {
            indexOfElement = index;
            break;
          }
        }

        return indexOfElement === 0;
      }
    };
    // public
    Header.prototype.dispose = function dispose () {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Header._jQueryInterface = function _jQueryInterface () {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data || $.isEmptyObject(data)) {
          data = new Header(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Header;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  /*$(Selector.DATA_SPY).each(function () {
    console.log(this);
    var $element = $(this);
    Header._jQueryInterface.call($element, $element.data());
  });*/

  SWRNEU.ModuleLoader.register(Selector.DATA_SPY, Header, {
    dataKey: DATA_KEY,
    observe: false,
    initAfterPjax: false,
    disposeAfterPjax: false
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Header._jQueryInterface;
  $.fn[NAME].Constructor = Header;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Header._jQueryInterface;
  };

  return Header;

})(window.jQuery);
